module.exports = __webpack_public_path__ + "img/lightning.ff429cfd.svg";